import { BookOpen, Flame, Globe2, Layers, PenLine, ScrollText } from "lucide-react";
import { fmtNum } from "@/lib/studio";

const sum = (list, k) => list.reduce((a, u) => a + (u[k] || 0), 0);

export const StatTiles = ({ universes, streak }) => {
  const tiles = [
    ["universes", Globe2, "Universes", universes.length],
    ["entries", ScrollText, "Lore entries", sum(universes, "entries")],
    ["stories", BookOpen, "Stories", sum(universes, "stories")],
    ["chapters", Layers, "Chapters", sum(universes, "chapters")],
    ["words", PenLine, "Words in your stories", sum(universes, "words")],
    ["streak", Flame, "Day writing streak", streak.current, `Best ${streak.best}`],
  ];
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-testid="stats-tiles">
      {tiles.map(([k, Icon, label, value, sub], i) => (
        <div key={k} className="rounded-md border border-[#2D3442] bg-[#0F131A] p-5 animate-in fade-in slide-in-from-bottom-2 fill-mode-both duration-500" style={{ animationDelay: `${i * 60}ms` }} data-testid={`stats-tile-${k}`}>
          <Icon className="h-4 w-4 text-[#F59E0B]" />
          <div className="mt-3 font-display text-3xl text-[#F3EBDD]" data-testid={`stats-tile-${k}-value`}>{fmtNum(value)}</div>
          <div className="mt-1 text-xs text-[#A8A090]">{label}{sub && <span className="ml-1 text-[#7A7468]">· {sub}</span>}</div>
        </div>
      ))}
    </div>
  );
};
